import {
    SvgDesign,
    SvgFeedbackAndRevision,
    SvgFilesReady,
    SvgFindADesigner,
    SvgIdea,
    SvgSubmit,
} from '@99designs/design-services-common/images';
import { CollaborationMethod } from '../../types';
import type { HowItWorksProps } from './HowItWorks';

export const howItWorksContent = (type: CollaborationMethod): HowItWorksProps => {
    const baseImageUrl = 'https://99designs-start-static.imgix.net/product-details/how-it-works';

    const contestAndContestBundleContent: HowItWorksProps = {
        title: __('How a contest works'),
        steps: [
            {
                title: __('01.'),
                description: __('Write a design brief'),
                image: {
                    src: `${baseImageUrl}/contest-1.jpg`,
                    alt: __('A person saying that they need a logo and filling out a design brief'),
                },
            },
            {
                title: __('02.'),
                description: __('Designers submit concepts'),
                image: {
                    src: `${baseImageUrl}/contest-2.jpg`,
                    alt: __('Four different designers submitting their designs'),
                },
            },
            {
                title: __('03.'),
                description: __('Pick a winning design'),
                image: {
                    src: `${baseImageUrl}/contest-3.jpg`,
                    alt: __('A person saying they love the design and selecting it as the winner'),
                },
            },
        ],
    };

    const typeMapping: Record<CollaborationMethod, HowItWorksProps> = {
        [CollaborationMethod.Contest]: contestAndContestBundleContent,
        [CollaborationMethod.Care]: {
            title: __('How in-house VistaPrint design works'),
            steps: [
                {
                    title: __('01.'),
                    description: __('Describe what you need'),
                    image: <SvgDesign />,
                },
                {
                    title: __('02.'),
                    description: __('Submit your request'),
                    image: <SvgSubmit />,
                },
                {
                    title: __('03.'),
                    description: __('Receive your design'),
                    image: <SvgIdea />,
                },
            ],
        },
        [CollaborationMethod.ContestBundle]: contestAndContestBundleContent,
        [CollaborationMethod.OneToOneProject]: {
            title: __('How a 1-to-1 project works'),
            steps: [
                {
                    title: __('01.'),
                    description: __('Write a design brief'),
                    image: <SvgFindADesigner />,
                },
                {
                    title: __('02.'),
                    description: __('Choose a designer to work with'),
                    image: <SvgFeedbackAndRevision />,
                },
                {
                    title: __('03.'),
                    description: __('Collaborate on your design'),
                    image: <SvgFilesReady />,
                },
            ],
        },
        [CollaborationMethod.Studio]: {
            title: __('How a Studio project works'),
            steps: [
                {
                    title: __('Define'),
                    description: __("We'll help define your strategy and creative brief"),
                    image: {
                        src: `${baseImageUrl}/studio-1.jpg`,
                        alt: __('A person having an idea and another person capturing it'),
                    },
                },
                {
                    title: __('Collaborate'),
                    description: __('We present up to 9 logo concepts and capture your feedback'),
                    image: {
                        src: `${baseImageUrl}/studio-2.jpg`,
                        alt: __('Three designers and their different designs'),
                    },
                },
                {
                    title: __('Bring to Life'),
                    description: __("We'll apply your brand across your brand assets"),
                    image: {
                        src: `${baseImageUrl}/studio-3.jpg`,
                        alt: __('A person seeing their design on multiple assets'),
                    },
                },
            ],
        },
    };

    return typeMapping[type];
};
